import {Component, inject} from '@angular/core';
import {GatewaySvgComponent} from "src/app/presentation/common/icons/gateway-svg/gateway-svg.component";
import {Router} from '@angular/router';

@Component({
  selector: 'app-signal-strength-analysis-button',
  imports: [
    GatewaySvgComponent
],
  templateUrl: './signal-strength-analysis-button.component.html',
  styleUrl: './signal-strength-analysis-button.component.css'
})
export class SignalStrengthAnalysisButtonComponent {

  private router = inject(Router);

  open(url: string): void {
    this.router.navigate([url]);
  }
}
